import { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import InputMask from 'react-input-mask';
import { useOffers } from '../../../Providers/OffersProvider';
import SelectBox from 'devextreme-react/select-box';

const AddInvestor = ({ show, handleOnHide, newInvestor, setNewInvestor, selectedTypeId }) => {
    const { investorsTypes } = useOffers()
    const [errorText, setErrorText] = useState('')
    const [selectedType, setSelectedType] = useState(null)

    useEffect(() => {
        if (show) {
            setErrorText('')
            setNewInvestor(prev => ({
                ...prev,
                isAdded: false
            }))
        }
    }, [show])

    useEffect(() => {
        if (selectedTypeId != -1) {
            const paddedId = selectedTypeId.toString().padStart(3, '0')
            const selectedType = investorsTypes.find(i => i.objectTypeId === paddedId)
            setSelectedType(selectedType)
        }
    }, [selectedTypeId])

    const handleInputChange = (e, prop) => {
        setNewInvestor(prev => ({
            ...prev,
            [prop]: e.target.value
        }))
    }
    const handleSelectBoxChange = (e) => {
        if (e.value) {
            setSelectedType(e.value)
            setNewInvestor(prev => ({
                ...prev,
                objectId: e.value.objectTypeId
            }))
        }
    }
    const handleSaveInvestor = () => {
        setErrorText('')
        if (!newInvestor.name || newInvestor.name.trim() === '') {
            setErrorText('Prosze uzupełnić nazwe')
            return
        }
        if (!newInvestor.objectId || newInvestor.objectId == -1) {
            setErrorText('Prosze wybrać typ inwestycji')
            return
        }
        if (!newInvestor.street || newInvestor.street.trim() === '') {
            setErrorText('Prosze uzupełnić ulice')
            return
        }
        if (!newInvestor.city || newInvestor.city.trim() === '') {
            setErrorText('Prosze uzupełnić miasto')
            return
        }
        if (!newInvestor.zipCode || newInvestor.zipCode.trim() === '') {
            setErrorText('Prosze uzupełnić kod pocztowy')
            return
        }
        setNewInvestor(prev => ({
            ...prev,
            isAdded: true
        }))
        handleOnHide()
    }

    return (
        <Modal size='lg' show={show} onHide={handleOnHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Dodaj nowe miejsce inwestycji</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-6 d-flex">
                        <Form.Control placeholder='Nazwa' value={newInvestor.name} onChange={(e) => handleInputChange(e, 'name')} />
                        <span className='error-text-color'>&nbsp;*</span>
                    </div>
                    <div className="col">
                        <div className="row">
                            <div className="col" style={{ paddingRight: '0px' }}>
                                <SelectBox
                                    items={investorsTypes}
                                    value={selectedType}
                                    placeholder="Typ"
                                    noDataText='Brak danych'
                                    onValueChanged={(e) => handleSelectBoxChange(e)}
                                    displayExpr="objectTypeName"
                                /></div>
                            <div className="col-auto" style={{ paddingLeft: '0px' }}>
                                <span className='error-text-color'>&nbsp;*</span></div>
                        </div>

                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-6 col-xl d-flex">
                        <Form.Control placeholder='Ulica' value={newInvestor.street} onChange={(e) => handleInputChange(e, 'street')} />
                        <span className='error-text-color'>&nbsp;*</span>
                    </div>
                    <div className="col-6 col-xl-3">
                        <Form.Control placeholder='Numer domu' value={newInvestor.houseNum} onChange={(e) => handleInputChange(e, 'houseNum')} />
                    </div>
                    <div className="col-6 col-xl-3 mt-3 mt-xl-0">
                        <Form.Control placeholder='Numer lokalu' value={newInvestor.localNum} onChange={(e) => handleInputChange(e, 'localNum')} />
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-12 col-xl d-flex">
                        <Form.Control placeholder='Miasto' value={newInvestor.city} onChange={(e) => handleInputChange(e, 'city')} />
                        <span className='error-text-color'>&nbsp;*</span>
                    </div>
                    <div className="col-12 col-xl-2 d-flex mt-3 mb-3 mt-xl-0 mb-xl-0">
                        <InputMask
                            mask="99-999"
                            value={newInvestor.zipCode}
                            onChange={(e) => handleInputChange(e, 'zipCode')}>
                            {(inputProps) => (
                                <Form.Control
                                    {...inputProps}
                                    placeholder="Kod pocztowy"
                                />
                            )}
                        </InputMask>
                        <span className='error-text-color'>&nbsp;*</span>
                    </div>
                    <div className="col-12 col-xl">
                        <Form.Control placeholder='Opis' value={newInvestor.description} onChange={(e) => handleInputChange(e, 'description')} />
                    </div>
                </div>
                <div className="row mt-2">
                    <span>
                        <span className='error-text-color'>*</span> Pole wymagane
                    </span>
                </div>
                <div className="col d-flex align-items-center justify-content-center mt-4">
                    <b className='error-text-color'>{errorText}</b>
                </div>

                <div className="row mt-4 ms-5 me-5">
                    <button className='btn-app-primary' onClick={handleSaveInvestor}>Zapisz</button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default AddInvestor